import { useEffect, useState } from "react";

// ui
import { Box } from "@mui/material";

// Table
import { ConstTable } from "../component/Table";

// Bar
import TableTopBar from "../component/TableTopBar";
import SerchSideBar from "../component/SerchSideBar";
import AiChatSideBar from "../component/AiChatSideBar";

// Modal
import { DataDetailModal } from "../component/detail/DataDetailModal";
import { GetXLSXConfirmPaymentModal } from "../component/GetXLSXConfirmPaymentModal";

// jotai
import { useAtomValue, useSetAtom } from "jotai";
import { AppAtoms } from "../lib/store";
import { useWindowSize } from "../lib/useWindowSize";

// API
import {
  getPaymentConfirmExcelRecords,
  getPaymentConfirmExcelRecord,
} from "../api/paymentConfirmExcelRecord";
import { getPaymentConfirmExcel } from "../api/paymentConfirmExcel";
import {
  getSerchProducts,
  getSerchHighRankCompanys,
  getSerchSaleCompanys,
  getSerchAccountStaffs,
  getSerchAccountSales,
} from "../api/serch";

// InterFace
import { paymentConfirmTableColumn } from "../config/paymentConfirm";
import { paymentConfirmSumTableColumn } from "../config/paymentConfirmSum";
import { paymentConfirmSumSmartTableColumn } from "../config/paymentConfirmSumSmart";
import { dataDifine } from "../config/dataInterface";

// OtherFunc
import { getFirstYear, getOneYear } from "../lib/other";
import { CONST } from "../config/const";

function PaymentConfirm() {
  const { windowWidth, windowHeight } = useWindowSize();
  const setIsLoading = useSetAtom(AppAtoms.isLoading);
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const loginUser = useAtomValue(AppAtoms.loginUser);

  // 各権限毎のヘッダーメニューの編集
  const addDataTypes: { auth: string[]; name: string }[] = [];
  const addCSVDataTypes: { auth: string[]; name: string }[] = [];
  const getXLSXDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: ["マスターアカウント", "パートナー"],
      name: "明細ダウンロード",
    },
  ];
  const editDatasTypes: { auth: string[]; name: string }[] = [];

  const [addDataNames, setAddDataNames] = useState<string[]>([]);
  const [addDataName, setAddDataName] = useState<string>("");
  const [addCSVDataNames, setAddCSVDataNames] = useState<string[]>([]);
  const [addCSVDataName, setAddCSVDataName] = useState<string>("");
  const [getXLSXDataNames, setGetXLSXDataNames] = useState<string[]>([]);
  const [getXLSXDataName, setGetXLSXDataName] = useState<string>("");
  const [editDatasNames, setEditDatasNames] = useState<string[]>([]);
  const [editDatasName, setEditDatasName] = useState<string>("");

  useEffect(() => {
    let addDataNames: string[] = [];
    let addCSVDataNames: string[] = [];
    let getXLSXDataNames: string[] = [];
    let editDatasNames: string[] = [];
    addDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        addDataNames.push(dataType.name);
      }
    });
    setAddDataNames(addDataNames);
    addCSVDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        addCSVDataNames.push(dataType.name);
      }
    });
    setAddCSVDataNames(addCSVDataNames);
    getXLSXDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        getXLSXDataNames.push(dataType.name);
      }
    });
    setGetXLSXDataNames(getXLSXDataNames);
    editDatasTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        editDatasNames.push(dataType.name);
      }
    });
    setEditDatasNames(editDatasNames);
  }, [loginUser]);

  useEffect(() => {
    if (getXLSXDataName === "明細ダウンロード") {
      setGetXLSXStatus({
        ...getXLSXStatus,
        status: "open",
      });
    }
  }, [getXLSXDataName]);

  // テーブルデータ
  const [fetchData, setFetchData] = useState<dataDifine[]>([]);
  const [fetchSumData, setFetchSumData] = useState<dataDifine[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);

  // データ詳細
  const [dataDetail, setDataDetail] = useState<{
    [key: string]: number | string;
  } | null>(null);

  // 検索欄、テーブル等の高さ
  const [serchOpen, setSerchOpen] = useState(true);
  const [aiChatOpen, setAiChatOpen] = useState(false);
  const [tableHeight, setTableHeight] = useState("calc(100vh - 110px)");
  useEffect(() => {
    const tableHeight = isSmartPhone
      ? "calc(100vh - 190px)"
      : !serchOpen
      ? windowWidth > 850
        ? "calc(100vh - 199px)"
        : "calc(100vh - 215px)"
      : windowWidth > 1150
      ? "calc(100vh - 199px)"
      : "calc(100vh - 215px)";
    setTableHeight(tableHeight);
  }, [isSmartPhone, windowWidth, serchOpen]);

  // 表示数・ページ
  const [displayNumber, setDisplayNumber] = useState(50);
  const displayNumbers = [25, 50, 100, 250, 500];
  const [pageNumber, setPageNumber] = useState(1);
  const [maxPageNumber, setMaxPageNumber] = useState(1);

  // 検索項目
  const firstYear = getFirstYear();
  const { thisYear, thisMonth, lastYear, lastMonth } = getOneYear();

  const serchColumn: { [key: string]: string } =
    paymentConfirmTableColumn.dataColumn.reduce((column, difine) => {
      if (difine.serch === true) {
        if (difine.serchType === "date") {
          return {
            ...column,
            [difine.key + "_start"]: "",
            [difine.key + "_end"]: "",
          };
        } else if (difine.serchType === "payment_year_month") {
          return {
            ...column,
            payment_year: thisYear.toString(),
            payment_month: thisMonth.toString(),
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
          };
        }
      } else {
        return {
          ...column,
        };
      }
    }, {});
  const [serchString, setSerchString] = useState(serchColumn);
  const [serchStringView, setSerchStringView] = useState(serchColumn);

  // 顧客一覧取得
  async function getTableData(edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const fetchData = await getPaymentConfirmExcelRecords({
      ...serchString,
      displayNumber,
      pageNumber,
    });
    if (fetchData === null) {
      setFetchData([]);
      setFetchSumData([]);
      setTotalCount(0);
      setMaxPageNumber(1);
      setPageNumber(1);
    } else if (fetchData) {
      setFetchData(fetchData.paymentConfirmExcelRecords);
      setFetchSumData(fetchData.paymentConfirmExcelSumRecords);
      const countPaymentConfirmExcelRecords = Number(
        fetchData.countPaymentConfirmExcelRecords
      );
      setTotalCount(countPaymentConfirmExcelRecords);
      setMaxPageNumber(
        Math.ceil(countPaymentConfirmExcelRecords / displayNumber)
      );
    }
    if (!edit) {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    getTableData(false);
  }, [serchString, displayNumber, pageNumber]);

  // 詳細取得
  async function getDataDetail(key: { [key: string]: string }, edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const id = key.id;
    setIsLoading(true);
    const dataDetail = await getPaymentConfirmExcelRecord({
      ...serchString,
      id,
    });
    setDataDetail(dataDetail);
    if (!edit) {
      setIsLoading(false);
    }
  }

  // 明細Excel取得
  const [getXLSXStatus, setGetXLSXStatus] = useState<{
    status: "none" | "open" | "getting" | "result" | "loading" | "error";
    message: string;
    sale_company_id: number | null;
    sale_company_name: string;
    payment_year: string;
    payment_month: string;
  }>({
    status: "none",
    message: "",
    sale_company_id: null,
    sale_company_name: "",
    payment_year: thisYear.toString(),
    payment_month: thisMonth.toString(),
  });
  useEffect(() => {
    if (getXLSXStatus.status === "loading") {
      setIsLoading(true);
    } else if (getXLSXStatus.status !== "none") {
      setIsLoading(false);
    }
  }, [getXLSXStatus]);

  async function getXLSXFunc() {
    setGetXLSXStatus({
      ...getXLSXStatus,
      status: "loading",
    });
    const responce = await getPaymentConfirmExcel({
      payment_year: getXLSXStatus.payment_year,
      payment_month: getXLSXStatus.payment_month,
      payment_sale_company_id: getXLSXStatus.sale_company_id,
    });
    if (responce != "None") {
      const url = responce;
      const link = document.createElement("a");
      link.href = responce;
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(url);
      link.parentNode?.removeChild(link);
      setGetXLSXStatus({
        ...getXLSXStatus,
        status: "result",
        message: "ダウンロードが成功しました。",
      });
    } else {
      setGetXLSXStatus({
        ...getXLSXStatus,
        status: "error",
      });
    }
  }

  // 上位店一覧
  const [highRankCompanyList, setHighRankCompanyList] = useState<
    { id: number; high_rank_company_name: string }[]
  >([]);
  const [highRankCompanyNameList, setHighRankCompanyNameList] = useState([""]);
  // 上位店一覧取得
  async function getHighRankCompanyList() {
    const fetchData = await getSerchHighRankCompanys();
    if (fetchData === null) {
      setHighRankCompanyList([]);
    } else if (fetchData) {
      setHighRankCompanyList(
        fetchData.highRankCompanys as {
          id: number;
          high_rank_company_name: string;
        }[]
      );
      let highRankCompanyNameList = [""];
      fetchData.highRankCompanys.map(
        (company: { id: number; high_rank_company_name: string }) => {
          if (
            !highRankCompanyNameList.includes(company.high_rank_company_name)
          ) {
            highRankCompanyNameList.push(company.high_rank_company_name);
          }
        }
      );
      setHighRankCompanyNameList(highRankCompanyNameList);
    }
  }

  // 商材一覧
  const [productList, setProductList] = useState<
    { id: number; high_rank_company_id: number; product_name: string }[]
  >([]);
  const [productNameList, setProductNameList] = useState([""]);
  // 上位店一覧取得
  async function getProductList() {
    const fetchData = await getSerchProducts();
    if (fetchData === null) {
      setProductList([]);
    } else if (fetchData) {
      setProductList(
        fetchData.products as {
          id: number;
          high_rank_company_id: number;
          product_name: string;
        }[]
      );
      let productNameList = [""];
      fetchData.products.map(
        (company: {
          id: number;
          high_rank_company_id: number;
          product_name: string;
        }) => {
          if (!productNameList.includes(company.product_name)) {
            productNameList.push(company.product_name);
          }
        }
      );
      setProductNameList(productNameList);
    }
  }

  // パートナー一覧
  const [companyList, setCampanyList] = useState<
    { id: number; sale_company_name: string }[]
  >([]);
  const [companyNameList, setCampanyNameList] = useState([""]);
  // パートナー一覧取得
  async function getSaleCompanysList() {
    const fetchData = await getSerchSaleCompanys();
    if (fetchData === null) {
      setCampanyList([]);
    } else if (fetchData) {
      setCampanyList(
        fetchData.saleCompanys as { id: number; sale_company_name: string }[]
      );
      let companyNameList = [""];
      fetchData.saleCompanys.map(
        (company: { id: number; sale_company_name: string }) => {
          if (!companyNameList.includes(company.sale_company_name)) {
            companyNameList.push(company.sale_company_name);
          }
        }
      );
      setCampanyNameList(companyNameList);
    }
  }
  // スタッフアカウント一覧
  const [accountStaffList, setAccountStaffList] = useState<
    { id: number; account_name: string }[]
  >([]);
  const [accountStaffNameList, setAccountStaffNameList] = useState([""]);
  async function getSaleAccountStaffsList() {
    const fetchData = await getSerchAccountStaffs();
    if (fetchData === null) {
      setAccountStaffList([]);
    } else if (fetchData) {
      setAccountStaffList(
        fetchData.accountStaffs as { id: number; account_name: string }[]
      );
      let accountStaffNameList = [""];
      fetchData.accountStaffs.map(
        (accountStaff: { id: number; account_name: string }) => {
          if (!accountStaffNameList.includes(accountStaff.account_name)) {
            accountStaffNameList.push(accountStaff.account_name);
          }
        }
      );
      setAccountStaffNameList(accountStaffNameList);
    }
  }
  // スタッフアカウント一覧
  const [accountSaleList, setAccountSaleList] = useState<
    { id: number; account_name: string }[]
  >([]);
  const [accountSaleNameList, setAccountSaleNameList] = useState([""]);
  async function getSaleAccountSalesList() {
    const fetchData = await getSerchAccountSales();
    if (fetchData === null) {
      setAccountSaleList([]);
    } else if (fetchData) {
      setAccountSaleList(
        fetchData.accountSales as { id: number; account_name: string }[]
      );
      let accountSaleNameList = [""];
      fetchData.accountSales.map(
        (accountSale: { id: number; account_name: string }) => {
          if (!accountSaleNameList.includes(accountSale.account_name)) {
            accountSaleNameList.push(accountSale.account_name);
          }
        }
      );
      setAccountSaleNameList(accountSaleNameList);
    }
  }
  useEffect(() => {
    getHighRankCompanyList();
    getSaleCompanysList();
    getProductList();
    getSaleAccountStaffsList();
    getSaleAccountSalesList();
  }, []);

  const handleSetSerchOpen = (open: boolean) => {
    setSerchOpen(open);
    if (open) setAiChatOpen(false);
  };
  const handleSetAiChatOpen = (open: boolean) => {
    setAiChatOpen(open);
    if (open) setSerchOpen(false);
  };

  return (
    <Box
      style={{
        width: isSmartPhone
          ? "calc(100% - 31px)"
          : (serchOpen || aiChatOpen)
          ? "calc(100% - 331px)"
          : "calc(100% - 31px)",
        height: isSmartPhone ? "calc(100vh - 120px)" : "calc(100vh - 40px)",
      }}
    >
      <TableTopBar
        serch={true}
        serchOpen={serchOpen}
        setSerchOpen={handleSetSerchOpen}
        addDataNames={addDataNames}
        addDataName={addDataName}
        setAddDataName={setAddDataName}
        addCSVDataNames={addCSVDataNames}
        addCSVDataName={addCSVDataName}
        setAddCSVDataName={setAddCSVDataName}
        getXLSXDataNames={getXLSXDataNames}
        getXLSXDataName={getXLSXDataName}
        setGetXLSXDataName={setGetXLSXDataName}
        editDatasNames={editDatasNames}
        editDatasName={editDatasName}
        setEditDatasName={setEditDatasName}
        editIDs={[]}
        columnSettingOpen={false}
        openColumnSettingWindow={() => {}}
        aiChatOpen={aiChatOpen}
        setAiChatOpen={handleSetAiChatOpen}
      />
      <Box style={{ display: "flex" }}>
        {(serchOpen || aiChatOpen) && isSmartPhone ? null : (
          <Box
            style={{
              width: isSmartPhone ? undefined : "100%",
            }}
          >
            <Box
              style={{
                width: isSmartPhone ? undefined : "100%",
                margin: isSmartPhone ? undefined : "10px 15px",
                height: isSmartPhone ? undefined : tableHeight,
                maxHeight: isSmartPhone ? undefined : tableHeight,
              }}
            >
              <ConstTable
                getTableData={getTableData}
                tableType={"main"}
                serchOpen={serchOpen}
                aiChatOpen={aiChatOpen}
                tableHeight={tableHeight}
                tableColumn={paymentConfirmTableColumn}
                dataColumn={[]}
                rows={fetchData}
                displayNumber={displayNumber}
                setDisplayNumber={setDisplayNumber}
                displayNumbers={displayNumbers}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
                maxPageNumber={maxPageNumber}
                totalCount={totalCount}
                getDataDetail={getDataDetail}
                getSubTableName={{
                  name: "",
                  key: {},
                  subData: [],
                }}
                setGetSubTableName={() => {}}
                getSubTableDetail={{
                  name: "",
                  key: {},
                  dataDetail: null,
                }}
                setGetSubTableEditDirect={() => {}}
                setGetSubTableDetail={() => {}}
                setGetSubTableAdd={() => {}}
                getSubSubTableName={{
                  name: "",
                  key: {},
                  subData: [],
                }}
                setGetSubSubTableName={() => {}}
                getSubSubTableDetail={{
                  name: "",
                  key: {},
                  dataDetail: null,
                }}
                setGetSubSubTableDetail={() => {}}
                setGetSubSubTableAdd={() => {}}
                setGetSubSubTableEditDirect={() => {}}
                tableTitle={
                  isSmartPhone || loginUser?.authority === "パートナー"
                    ? "明細一覧" +
                      "(" +
                      serchString["payment_year"] +
                      "/" +
                      serchString["payment_month"] +
                      ")"
                    : "確定済 - 明細一覧" +
                      "(" +
                      serchString["payment_year"] +
                      "/" +
                      serchString["payment_month"] +
                      ")"
                }
                switchTableCheckBox={() => {}}
                allCheckFlg={false}
                switchAllTableCheckBox={() => {}}
                editIDs={[]}
                setEditIDs={() => {}}
                setEditDatasName={setEditDatasName}
                setGetSubMainTableName={() => {}}
                setTableOriginalFunc={() => {}}
                sortColumn={[]}
                setSortColumn={() => {}}
              />
            </Box>

            <Box
              style={{
                width: isSmartPhone ? undefined : "100%",
                margin: isSmartPhone ? undefined : "0px 15px",
                height: isSmartPhone
                  ? undefined
                  : !serchOpen
                  ? windowWidth > 850
                    ? "80px"
                    : "96px"
                  : windowWidth > 1150
                  ? "80px"
                  : "96px",
                maxHeight: isSmartPhone
                  ? undefined
                  : !serchOpen
                  ? windowWidth > 850
                    ? "80px"
                    : "96px"
                  : windowWidth > 1150
                  ? "80px"
                  : "96px",
              }}
            >
              <ConstTable
                getTableData={getTableData}
                tableType={"sub"}
                serchOpen={serchOpen}
                tableHeight={
                  !serchOpen
                    ? windowWidth > 850
                      ? "80px"
                      : "96px"
                    : windowWidth > 1150
                    ? "80px"
                    : "96px"
                }
                tableColumn={
                  isSmartPhone
                    ? paymentConfirmSumSmartTableColumn
                    : paymentConfirmSumTableColumn
                }
                dataColumn={[]}
                rows={fetchSumData}
                displayNumber={displayNumber}
                setDisplayNumber={setDisplayNumber}
                displayNumbers={displayNumbers}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
                maxPageNumber={maxPageNumber}
                totalCount={totalCount}
                getDataDetail={() => {}}
                getSubTableName={{
                  name: "",
                  key: {},
                  subData: [],
                }}
                setGetSubTableName={() => {}}
                getSubTableDetail={{
                  name: "",
                  key: {},
                  dataDetail: null,
                }}
                setGetSubTableEditDirect={() => {}}
                setGetSubTableDetail={() => {}}
                setGetSubTableAdd={() => {}}
                getSubSubTableName={{
                  name: "",
                  key: {},
                  subData: [],
                }}
                setGetSubSubTableName={() => {}}
                getSubSubTableDetail={{
                  name: "",
                  key: {},
                  dataDetail: null,
                }}
                setGetSubSubTableDetail={() => {}}
                setGetSubSubTableAdd={() => {}}
                setGetSubSubTableEditDirect={() => {}}
                tableTitle={""}
                switchTableCheckBox={() => {}}
                allCheckFlg={false}
                switchAllTableCheckBox={() => {}}
                editIDs={[]}
                setEditIDs={() => {}}
                setEditDatasName={() => {}}
                setGetSubMainTableName={() => {}}
                setTableOriginalFunc={() => {}}
                sortColumn={[]}
                setSortColumn={() => {}}
              />
            </Box>
          </Box>
        )}
        {serchOpen ? (
          <SerchSideBar
            setSerchOpen={handleSetSerchOpen}
            tableHeight={tableHeight}
            tableColumn={paymentConfirmTableColumn}
            dataColumn={[]}
            firstYear={firstYear}
            thisYear={thisYear}
            serchColumn={serchColumn}
            setSerchString={setSerchString}
            companyNameList={companyNameList}
            companyGroupNameList={[]}
            highRankCompanyNameList={highRankCompanyNameList}
            categoryNameList={[]}
            productNameList={productNameList}
            accountSaleNameList={accountSaleNameList}
            accountStaffNameList={accountStaffNameList}
            serchStringView={serchStringView}
            setSerchStringView={setSerchStringView}
          />
        ) : null}
        {aiChatOpen && (
          <AiChatSideBar
            open={aiChatOpen}
            setOpen={handleSetAiChatOpen}
            pageName="PaymentConfirm"
          />
        )}
      </Box>
      <DataDetailModal
        onModal={dataDetail !== null}
        swCloseModal={() => setDataDetail(null)}
        detailTitle={paymentConfirmTableColumn.detailTitle}
        editAuth={paymentConfirmTableColumn.editAuth}
        dataColumn={paymentConfirmTableColumn.dataColumn}
        subDataColumn={[]}
        dataDetail={dataDetail}
        setEditData={() => {}}
        option={false}
        setEditProduct={() => {}}
        dataDetailOption={[]}
        dataDetailOptionSelect={[]}
        dataDetailHistory={[]}
        selectHistory={0}
        getOldDataDetail={() => {}}
        getGroupList={() => {}}
        setEditProductOptionPlans={() => {}}
        setEditProductOptionContents={() => {}}
        setEditTossUpFormOptionProducts={() => {}}
        setEditOutsideServices={() => {}}
        setSelectServiseInfo={() => {}}
        setSelectTossUpInfo={() => {}}
      />
      <GetXLSXConfirmPaymentModal
        onModal={
          getXLSXStatus.status !== "none" && getXLSXStatus.status !== "loading"
        }
        swCloseModal={() => {
          setGetXLSXStatus({
            status: "none",
            message: "",
            sale_company_id: null,
            sale_company_name: "",
            payment_year: thisYear.toString(),
            payment_month: thisMonth.toString(),
          });
          setGetXLSXDataName("");
        }}
        getXLSXStatus={getXLSXStatus}
        setGetXLSXStatus={setGetXLSXStatus}
        getXLSXFunc={getXLSXFunc}
        firstYear={firstYear}
        thisYear={thisYear}
        thisMonth={thisMonth}
        companyList={companyList}
      />
    </Box>
  );
}
export default PaymentConfirm;
